import { getPartnerSignupConnectorByCode } from '@avalara/bat-apps-shared/constants';
import { t } from '@avalara/bat-apps-shared/i18n';
import type { Connector } from '@avalara/types/index';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import conf from '../../conf';
import analytics from '../../lib/analytics';
import { isFormOneIncomplete } from '../../lib/shared-signup';
import { selectState } from '../../selectors';
import Banner from '../banner';
import { showThirdBullet as shouldShowThirdBullet } from '../helpers/sign-up';
import StartFormFields from '../shared/forms/start';
import { SignUpForm } from '../styled/components/sign-up';
import { FlexContainerRowLRPadding, FormNavButtons, PageWrapper } from '../styled/skylab/page';
import CheckoutPurchaseInfo from './checkout-purchase-info';

const Start = () => {
  const {
    abTesting: { group: abGroup },
    avataxSignup: { partnerSignup },
    data: {
      connectors: { data: connectors },
    },
    sharedSignup,
    system: { activeFlow },
  } = useSelector(selectState);

  const isDirectToBuy = Boolean(partnerSignup) && activeFlow === 'avatax-direct-buy';
  const disableNextButton = isFormOneIncomplete(sharedSignup);
  const showThirdBullet = shouldShowThirdBullet(abGroup, partnerSignup);
  const searchParams = new URLSearchParams(window.location.search);

  // biome-ignore lint/correctness/useExhaustiveDependencies: leaving as is
  useEffect(() => {
    const partner = (searchParams.get('partner') || '').toUpperCase();
    const connectorId = getPartnerSignupConnectorByCode(partner)?.connectorId;
    const connector: Partial<Connector> = connectors.find((c) => c.id === connectorId) || {};

    if (connector?.name == null) return;
    analytics.page('SIGNUP_START', { connector: connector.name, abBucket: abGroup });
  }, []);

  return (
    <div>
      <Banner
        backgroundImage={`${conf.ASSET_PATH}/assets/images/banner-background.png`}
        image={`${conf.ASSET_PATH}/assets/images/account_w.svg`}
        partnerSignup={partnerSignup}
        primaryText={t('client.general.avalara-avatax')}
        secondaryText='Tax compliance done right'
      />
      <PageWrapper>
        <FlexContainerRowLRPadding>
          <div>
            <h3 data-ref='buy.signup.start.heaader' className='text-md'>
              {t('client.headings.get-started-quickly')}
            </h3>
            <SignUpForm>
              <StartFormFields />
              <br />
            </SignUpForm>
            <FormNavButtons>
              <Link to={`/buy/company?${searchParams}`}>
                <button
                  type='button'
                  data-ref='buy.signup.start.next-button'
                  className='primary large'
                  disabled={disableNextButton}
                >
                  {'Continue'}
                </button>
              </Link>
            </FormNavButtons>
          </div>
          <CheckoutPurchaseInfo
            start={true}
            partnerSignup={partnerSignup}
            isDirectToBuy={isDirectToBuy}
            showThirdBullet={showThirdBullet}
          />
        </FlexContainerRowLRPadding>
      </PageWrapper>
    </div>
  );
};

export default Start;
